import { createAsyncThunk } from "@reduxjs/toolkit";
import { type Refund } from "../../../domain/entities/first-purchase";
import { type FirstPurchaseDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const getRefund = createAsyncThunk<
  Refund,
  void,
  { dispatch: FirstPurchaseDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.GET_REFUND, async (_, { extra }) => {
  return await extra.firstPurchaseRepo.getRefund();
});
